import dynStorage from '@/utils/storage-dynamic';

const KEY_DARK_THEME = 'dark-theme'

const state = {
    is_dark_theme: false,
};

const getters = {
    is_dark_theme: state => state.is_dark_theme,
};

const actions = {
    loadDarkTheme({ commit, getters }) {
        if (getters.is_dark_theme_enabled) {
            const isDark = dynStorage.get(KEY_DARK_THEME)

            const systemColorSchemeQueryDark = window.matchMedia('(prefers-color-scheme: dark)')

            if (systemColorSchemeQueryDark) {
                systemColorSchemeQueryDark.onchange = (e)=> {
                    commit('SET_DARK_THEME', e.matches)
                }
            }

            if (isDark === 'true' || systemColorSchemeQueryDark?.matches) {
                commit('SET_DARK_THEME', true)
            }
        } else {
            commit('SET_DARK_THEME', false)
        }
    }
};

const mutations = {
    SET_DARK_THEME(state, value) {
        state.is_dark_theme = value

        const body = document.body

        if (value) {
            dynStorage.set(KEY_DARK_THEME, value, null, true)
            body.setAttribute("data-theme", "dark")
        } else {
            dynStorage.remove(KEY_DARK_THEME);
            body.removeAttribute("data-theme")
        }
    },
};

export default {
    state,
    getters,
    mutations,
	actions,
};
